import React from 'react';
import * as C from "../componentsM/index"

const Assessment = () => {
    return (
        <>

            <C.Hero title={"ASSESSMENT"}
                image={"/hero/10.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <p>Assessments help us to identify what students know, understand and can do throughout their learning. A variety of assessment strategies and tools are used to assess students in the PYP (including but not limited to presentations, hands on activities and oral assessments) keeping in mind their different learning needs and styles.</p>


                    <p>Students are initially assessed on their prior knowledge, formally known as the pre-assessment, formative assessments are ongoing throughout the unit- assessing what students have learnt, allowing the teacher to plan the next stage of the learning process accordingly and summative assessments which are end of unit assessments.</p>

                </div>
            </section>

        </>

    )
}

export default Assessment